import ComponentWithSocket from '../../lib/component'
import { Component } from 'vue-property-decorator';

import * as Store from '../../store';

import template from './auction-live.vue';
import moment from 'moment';

import WebsocketClient, { WebsocketsListener } from '../../utils/ws';

@Component({
    mixins: [template]
})

export default class LiveAuction extends ComponentWithSocket {

    private data: {
        id: string,
        chooseLoading: boolean,
        bidError: string,
        addRequestError: string,
        addRequestOpen: boolean,
        paddleNumber: string,
        customPrice?: number,
        isPriceOverride: boolean
        auction: any,
        lots: any[],
        current: any,
        prices: any,
        bidders: any[],
        lotsRequests: any[],
        canReviewLotRequests: boolean,
        isEditingCurrentPrice: boolean,
        updatedCurrentPrice?: number
    } = {
        id: '',
        bidError: '',
        addRequestError: '',
        addRequestOpen: false,
        chooseLoading: false,
        paddleNumber: '',
        customPrice: undefined,
        isPriceOverride: false,
        auction: undefined,
        current: undefined,
        prices: undefined,
        lots: [],
        bidders: [],
        lotsRequests: [],
        canReviewLotRequests: false,
        isEditingCurrentPrice: false,
        updatedCurrentPrice: undefined
    };

    public streamId: string  = '';

    public addRequest: {
        paddleNumber?: number,
        lotPosition?: number
    } = {
        paddleNumber: undefined,
        lotPosition: undefined
    }

    constructor() {

        super();

        this.wsListener.onGet('auctions', (success: boolean, data: any) => {

            Store.commitLoaderVisibility(this.$store, false);

            if (success) {
                this.data.auction = data;
            }

        });

        this.wsListener.onGet('lots', (success: boolean, data: any) => {
            if (success) {
                this.data.lots = data;
            }
        });

        this.wsListener.onPost('admin.live.preparing', (success: boolean, data: any) => {
            if (success) {
                this.data.auction = data;
            }
            else {
                alert(data)
            }
        });

        this.wsListener.onPost('admin.live.start', (success: boolean, data: any) => {
            if (success) {
                this.data.auction = data;
            }
            else {
                alert(data)
            }
        });

        this.wsListener.onPost('admin.live.done', (success: boolean, data: any) => {
            if (success) {
                this.data.auction = data;
            }
            else {
                alert(data)
            }
        });

        this.wsListener.onPost('admin.live.lotend', (success: boolean, data: any) => {
            if (!success) {
                alert(data)
            }
        });

        this.wsListener.onPost('admin.live.next', (success: boolean, data: any) => {
            if (!success) {
                alert(data)
            }
        });

        this.wsListener.onPost('admin.live.bids.choose', (success: boolean, data: any) => {

            this.data.chooseLoading = false

            if (success) {
                this.data.paddleNumber = ''
                this.data.bidError = ''
                this.data.customPrice = undefined
                this.data.isPriceOverride = false

                if (this.$refs.paddleNumber) {
                    (this.$refs.paddleNumber as any).focus();
                }

            }
            else {
                this.data.bidError = data
            }

        });

        this.wsListener.onGet('admin.live.current', (success: boolean, data: any) => {
            if (success) {
                this.data.current = data;
                this.data.prices = data.prices;
                this.data.bidders = data.bidders;
                this.data.canReviewLotRequests = !data.lot || data.lot.status == 2
            }
        });

        this.wsListener.onGet('admin.live.lots.requests', (success: boolean, data: any) => {
            if (success) {
                this.data.lotsRequests = data;
            }
            else {
                alert(data)
            }
        });

        this.wsListener.onPost('admin.live.lots.requests.accept', (success: boolean, data: any) => {
            if (success) {
                this.wsListener.sendGet('admin.live.lots.requests', {
                    auction: this.data.id
                });
            }
            else {
                alert(data)
            }
        });

        this.wsListener.onPost('admin.live.lots.requests', (success: boolean, data: any) => {
            if (success) {
                this.data.addRequestError = ''
                this.data.addRequestOpen = false
                this.addRequest = {
                    paddleNumber: undefined,
                    lotPosition: undefined
                }
                this.wsListener.sendGet('admin.live.lots.requests', {
                    auction: this.data.id
                })
            }
            else {
                this.data.addRequestError = data
            }
        });

        this.wsListener.onPost('admin.live.notifications.send', (success: boolean, data: any) => {
            if (success) {
                alert('Notificarile au fost trimise!')
            }
        })

    }

    beforeRouteLeave(to: any, from: any, next: any) {
        this._beforeLeave(to, from)
        next()
    }

    mounted() {

        this.data.id = this.$root.$route.params.id;

        Store.commitLoaderVisibility(this.$store, true);

        this.wsListener.sendGet('auctions', {
            _id: this.data.id
        });

        this.wsListener.sendGet('lots', {
            auction: this.data.id
        });

        // Get current status data
        this.wsListener.sendGet('admin.live.current', {
            auction: this.data.id
        });

        this.wsListener.sendGet('admin.live.lots.requests', {
            auction: this.data.id
        });

    }

    preparingLive() {
        this.wsListener.sendPost('admin.live.preparing', {
            auction: this.data.auction._id
        });
    }

    goLive() {
        this.wsListener.sendPost('admin.live.start', {
            auction: this.data.auction._id
        });
    }

    chooseBid(bidId?: string) {

        let mainData: any = {
            auction: this.data.auction._id,
            price: this.data.prices.current ? this.data.prices.current._id : undefined,
            lot: this.data.current && this.data.current.lot ? this.data.current.lot._id : undefined,
            isCustomPrice: !!this.data.customPrice,
            isPriceOverride: !!this.data.isPriceOverride,
            customPrice: this.data.customPrice
        };

        if (bidId) {
            mainData.bid = bidId;
        } else {
            mainData.number = this.data.paddleNumber;
        }

        this.wsListener.sendPost('admin.live.bids.choose', mainData);

        this.data.chooseLoading = true

    }

    undoChosenBid() {
        let mainData: any = {
            auction: this.data.auction._id,
            lot: this.data.current && this.data.current.lot ? this.data.current.lot._id : undefined,
            undoLastBid: true
        };

        this.wsListener.sendPost('admin.live.bids.choose', mainData);

        this.data.chooseLoading = true
    }

    markAsDone() {

        if (confirm('Esti sigur ca vrei sa inchizi licitatia ?')) {
            this.wsListener.sendPost('admin.live.done', {
                auction: this.data.auction._id
            });
        }

    }

    sendStartNotifications() {

        if (confirm('Esti sigur ca vrei sa trimiti notificarile de incepere a licitatiei ?')) {
            this.wsListener.sendPost('admin.live.notifications.send', {
                auction: this.data.auction._id
            });
        }

    }

    reloadAuction() {

        if (confirm('Esti sigur ca vrei sa resicronizezi licitatia pe toate dispozitivele online ?')) {
            this.wsListener.sendPost('admin.live.auction.reload', {
                auction: this.data.auction._id
            });
        }

    }

    prepareNextLot() {
        this.wsListener.sendPost('admin.live.lotend', {
            auction: this.data.auction._id
        });
    }

    loadNextLot() {
        this.wsListener.sendPost('admin.live.next', {
            auction: this.data.auction._id
        });
    }

    beautifyDateTime(dtt: any) {
        return moment(dtt)
            .format('llll');
    }

    timeAgo(dtt: any) {
        return moment(dtt)
            .fromNow();
    }

    getLotThumbnail(lot: any) {
        return lot.imagesData && lot.imagesData.length ? lot.imagesData[0].thumbnail : ''
    }

    acceptLotRequest(lot: any) {
        this.wsListener.sendPost('admin.live.lots.requests.accept', {
            auction: this.data.auction._id,
            lot: lot._id
        });
    }

    addLotRequest() {
        this.wsListener.sendPost('admin.live.lots.requests', {
            auction: this.data.auction._id,
            ...this.addRequest
        })
    }

    updateCurrentPrice() {
        const prevPrice = this.data.prices.prev ? parseInt(this.data.prices.prev.price) : 0
        const currentPrice = this.data.prices.current ? parseInt(this.data.prices.current.price) : 0

        if (
            this.data.updatedCurrentPrice && 
            this.data.updatedCurrentPrice > prevPrice &&
            this.data.updatedCurrentPrice < currentPrice
        ) {
            this.wsListener.sendPost('admin.live.current.price', {
                auction: this.data.auction._id,
                price: this.data.updatedCurrentPrice
            })
        } else {
            alert('Pretul introdus nu este valid!');
        }

        this.data.isEditingCurrentPrice = false
        this.data.updatedCurrentPrice = undefined
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--2!./src/views/auction-live/index.ts